import i18n from 'app-i18n';
import * as yup from 'yup';

export const addCustomRuleFormSchema = yup.object().shape({
  ruleType: yup.string().oneOf(['OR', 'AND']).default('OR'),
  products: yup
    .array(
      yup.object().shape({
        id: yup.string(),
        category: yup.string(),
        label: yup.string(),
      }),
    )
    .when('ruleType', {
      is: 'AND',
      then: schema =>
        schema.min(2, () =>
          i18n.t(
            'page.menus.recommendations.customRules.schema.errors.all.min',
          ),
        ),
    })
    .min(1, () => i18n.t('forms.errors.mixed.required'))
    .default([]),
  recommendationItemIds: yup
    .array(yup.string())
    .min(1, () => i18n.t('forms.errors.mixed.required'))
    .default([]),
});
